import { ScientificAnalysisConditionComponent, ScientificAnalysisStaticImplements } from '@/modules/scientific-analysis-module/components/scientific-analysis-filter-panel/scientific-analysis-filter-panel-conditionfactory'
import { ScientificAnalysisComparatorType, ScientificAnalysisConditionTypeEnum } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'
import { ScientificAnalysisComparisonType, ScientificAnalysisCondition, ScientificAnalysisConditionValidationErrorCode } from '@/modules/scientific-analysis-module/shared/scientific-analysis.models'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

interface SelectOption{
    id: string,
    label:string
}

@Component({
    components: {}
})
// eslint-disable-next-line no-use-before-define
    @ScientificAnalysisStaticImplements<ScientificAnalysisConditionComponent<ScientificAnalysisFilterPanelBoolean>>()
export default class ScientificAnalysisFilterPanelBoolean extends Vue {
    static COMPONENT_NAME = 'scientific-analysis-filter-panel-boolean'
    static ALLOWED_COMPARATORS: ScientificAnalysisComparatorType[] = [
        ScientificAnalysisComparatorType.EQUALS
    ]
    @Prop() condition!: ScientificAnalysisCondition
    AVAILABLE_OPTIONS: SelectOption[] = [{ id: 'true', label: 'scientificAnalysis.filterForm.booleanTrue' }, { id: 'false', label: 'scientificAnalysis.filterForm.booleanFalse' }]

    static canAccept(comparisonType: ScientificAnalysisComparisonType): boolean {
        return (!comparisonType.additionalInfo || comparisonType.additionalInfo === null || comparisonType.additionalInfo.length === 0) &&
            ScientificAnalysisFilterPanelBoolean.ALLOWED_COMPARATORS.includes(comparisonType.comparatorType) &&
            (comparisonType.conditionType === ScientificAnalysisConditionTypeEnum.BOOLEAN)
    }

    onSelect(selected: SelectOption | null):void {
        this.condition.value = selected ? selected.id : ''
        this.onModification()
    }

    @Emit('modification')
    private onModification():void { }

    _localizedOption(selected: SelectOption): string {
        return this.$t(selected.label) as string
    }

    get currentValue(): SelectOption | undefined {
        return this.AVAILABLE_OPTIONS.find(option => option.id === this.condition.value)
    }

    get _validate(): boolean {
        if (this.condition.value.length === 0) {
            this.condition.validationErrorCode = ScientificAnalysisConditionValidationErrorCode.EMPTY
        } else {
            this.condition.validationErrorCode = ScientificAnalysisConditionValidationErrorCode.NONE
        }
        return this.condition.validationErrorCode !== ScientificAnalysisConditionValidationErrorCode.NONE
    }
}
